import { AuditEntity } from "@app/common";
import { Column, Display, prop, required, Table } from "@messaia/cdk";
import { ContentType } from "../enums/content-type";
import { WrapTag } from "../enums/wrap-tag";

@Table({
    endpoint: 'content',
    duplicable: true,
    includes: ['Client']
})
export class Content extends AuditEntity {
    @prop()
    type: ContentType;

    @prop()
    sectionId: number;

    @Column()
    @Display($localize`:@@title:Title`)
    @required()
    title: string;

    @Column({ maxWidth: 190, showGtMd: true })
    @Display($localize`:@@name:Name`)
    @required()
    name: string;

    @prop()
    aliases: string;

    @prop()
    body: string;

    @prop()
    wrapTag: WrapTag = WrapTag.Section;

    @prop()
    layout: string;

    @prop()
    showTitle: boolean = true;

    @Column({
        name: 'client.displayName',
        endpoint: 'client?enabled=true&projection=id,name',
        maxWidth: 190,
        showGtLg: true
    })
    @Display($localize`:@@client:Client`)
    @required()
    clientId: number;

    @prop()
    default: boolean = false;

    @Column({ header: $localize`:@@enabled:Enabled`, event: 'toggle' })
    @prop()
    enabled: boolean = true;

    @prop()
    script: string;

    @prop()
    style: string;
}